// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delivery .envelope-icon[data-v-208f33c6]{color:#017acd}.delivery svg[data-v-208f33c6]{height:.88rem}.box-icon[data-v-208f33c6]{color:#017acd;height:1.3rem;width:1.3rem}.global[data-v-208f33c6]:after{box-shadow:none!important}.coins .coin[data-v-208f33c6]{width:1.333333rem}.coins span[data-v-208f33c6]:hover{color:#017acd;-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
